import { render, staticRenderFns } from "./DepartamentoRegional.vue?vue&type=template&id=143e7852&"
import script from "./DepartamentoRegional.vue?vue&type=script&lang=js&"
export * from "./DepartamentoRegional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports